import { ThemeProvider } from "@/components/providers/theme-provider";
import { SvgFilters } from "@/components/ui/svg-filters";
import { GlobalDrawer } from "@/components/drawer/global-drawer";
import { Routes, Route } from "react-router";
import { lazy, Suspense } from "react";
import { HomePage } from "@/pages/HomePage";
import { MobileHomePage } from "@/pages/MobileHomePage";
// Old switch-based detail page — superseded by the registry-driven V2 (which keeps
// it as a legacy fallback for the two retired slugs, imported transitively).
// import { CaseStudyDetailPage } from "@/pages/CaseStudyDetailPage";
import { PrivacyPolicyPage } from "@/pages/PrivacyPolicyPage";
import { SmoothScrollProvider } from "@/components/providers/smooth-scroll-provider";
import { useBreakpoint } from "@/hooks/useBreakpoint";
import { SpeedInsights } from '@vercel/speed-insights/react';

// Detail content is code-split out of the homepage bundle.
const CaseStudyDetailPageV2 = lazy(() =>
  import("@/pages/CaseStudyDetailPageV2").then((m) => ({
    default: m.CaseStudyDetailPageV2,
  })),
);

function DesktopApp() {
  return (
    <SmoothScrollProvider>
      <Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/case-studies/:slug" element={<CaseStudyDetailPageV2 />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        </Routes>
      </Suspense>
    </SmoothScrollProvider>
  );
}

function MobileApp() {
  return (
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<MobileHomePage />} />
        <Route path="/case-studies/:slug" element={<CaseStudyDetailPageV2 />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      </Routes>
    </Suspense>
  );
}

function App() {
  const { isMobile } = useBreakpoint();

  return (
    <ThemeProvider defaultTheme="dark" storageKey="vite-ui-theme">
      <SvgFilters />
      {isMobile ? <MobileApp /> : <DesktopApp />}
      <GlobalDrawer />
      <SpeedInsights />
    </ThemeProvider>
  );
}

export default App;
